import React from "react";
import { usePushProjectHistory } from "@planzone/view-models";
import { useMessage } from "../../components/useMessage";
import { events } from "@planzone/events";

function ProjectHistory() {
  const { pushProjectHistory } = usePushProjectHistory();

  useMessage(
    (message) =>
      message.type === events.retrieveProjectSucceeded &&
      pushProjectHistory(message.data),
  );

  return <React.Fragment />;
}

export { ProjectHistory };
